import {Box, IconButton} from '@material-ui/core';
import {Edit} from '@material-ui/icons';
import {PSingleLine} from 'components/TypographyShortcuts';
import {snakeCaseToCapitalCase} from '../locale/utils';
import {shortFields} from './fields';
import {useEffect, useState, useContext} from 'react';
import {AutoField} from '../fields';
import {useFormContext} from 'react-hook-form';
import get from 'lodash.get';
import {MiniFormContext} from './MiniFormContext';

const machineToHuman = {
    psix: 'PSIX',
    vessel_name: 'Vessel',
    service: 'Type of Service',
    imo_number: 'IMO',
    mmsi: 'MMSI',
    uscg_official_number: 'USCG Official Number',
    tonnage_type: 'Tonnage Type',
    length_tonnage: 'Length',
    engine_horsepower: 'HP',
    engine_mode_of_propulsion: 'Type of Propulsion',
    vessel_type: 'Type of Vessel',
    offshore_installation_MODU_type: 'MODU Type',
    offshore_installation_MODU_propulsion_type: 'MODU Propulsion',
    offshore_installation_FOI_type: 'FOI Ballast',
};

const PrintField = ({name, value, component = 'p'}) => {
    const newName = machineToHuman[name] || snakeCaseToCapitalCase(name);
    const tempVal = machineToHuman[value] || value;
    const newValue =
        tempVal === null || tempVal === '' || tempVal === undefined
            ? 'Unknown'
            : tempVal === 'false' || tempVal === false
            ? 'No'
            : tempVal === 'true' || tempVal === true
            ? 'Yes'
            : tempVal;

    return (
        <PSingleLine component={component}>
            <span style={{fontWeight: 'bold'}}>{newName}:</span> {newValue}
        </PSingleLine>
    );
};

const FieldDetail = ({name, value, optional = false, hide}) => {
    const {formEditable} = useContext(MiniFormContext);
    const editable = formEditable && !hide;
    const [editing, setEditing] = useState(false);
    const {errors} = useFormContext();
    const error = get(errors, name);

    const hidden = !editable || !editing || hide;

    useEffect(() => {
        if (!!error && editable) {
            setEditing(true);
        }
        // eslint-disable-next-line
    }, [error]);

    if (optional && !value) {
        return null;
    } else {
        return (
            <Box
                style={{
                    display: 'flex',
                    gap: '1em',
                    margin: hidden ? null : '1em 0px',
                }}
            >
                <Box style={{flexGrow: 1}}>
                    {!editing && !hide ? (
                        <PrintField
                            name={name}
                            value={value}
                            component='span'
                        />
                    ) : null}
                    <AutoField
                        field={shortFields[name]}
                        name={name}
                        variant='outlined'
                        size='small'
                        hidden={hidden}
                    />
                </Box>
                {editable ? (
                    <IconButton
                        onClick={() => setEditing(!editing)}
                        style={{padding: 0}}
                        data-cy={`edit-${name}`}
                    >
                        <Edit />
                    </IconButton>
                ) : null}
            </Box>
        );
    }
};

const PSIXField = ({vessel, name}) => {
    const isPsix = vessel?.origin === 'psix';
    if (isPsix) {
        return [
            <PrintField name={name} value={vessel?.[name]} key='label' />,
            <AutoField
                field={shortFields[name]}
                name={name}
                key='field'
                hidden
            />,
        ];
    } else {
        return <FieldDetail name={name} value={vessel?.[name]} />;
    }
};

export default FieldDetail;
export {PrintField, PSIXField};
